var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 58,
    viewBox: "0 0 59 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 58,
    height: 58,
    rx: 29,
    fill: "#F0F6FA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.125 36.7868H25.875C24.8781 36.7868 24.0625 35.9711 24.0625 34.9743V25.9118H21.1806C19.5675 25.9118 18.77 23.9543 19.9119 22.8124L28.2312 14.493C28.5699 14.1536 29.0296 13.9629 29.5091 13.9629C29.9885 13.9629 30.4482 14.1536 30.7869 14.493L39.1063 22.8124C40.2481 23.9543 39.4325 25.9118 37.8194 25.9118H34.9375V34.9743C34.9375 35.9711 34.1219 36.7868 33.125 36.7868ZM40.375 40.4118H18.625C17.6281 40.4118 16.8125 41.2274 16.8125 42.2243C16.8125 43.2211 17.6281 44.0368 18.625 44.0368H40.375C41.3719 44.0368 42.1875 43.2211 42.1875 42.2243C42.1875 41.2274 41.3719 40.4118 40.375 40.4118Z",
    fill: "#5396C7"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.c5073aaeb2fd422f04a346a5809cc20c.svg";
export { ForwardRef as ReactComponent };